export default __webpack_public_path__ + "static/media/contact.5fb34825.svg";